import { useMatchPlayerList } from 'core/shared/timeline/hooks'

import { useValorantMatchEditorState } from '../context'

export const usePlayerList = () => {
  const { mainPerspectiveInfo, matchId } = useValorantMatchEditorState()
  return useMatchPlayerList(matchId, mainPerspectiveInfo?.userId ?? '')
}
